import { createSlice } from '@reduxjs/toolkit';

interface AnalyticsState {
  enabled: boolean;
  timestamp: number | null;
}

export const initialState: AnalyticsState = {
  enabled: false,
  timestamp: null,
};

export const analyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    refresh: store => {
      store.enabled = false;
      store.timestamp = null;
    },
    enable: store => {
      store.enabled = true;
      store.timestamp = new Date().getTime();
    },
    disable: store => {
      store.enabled = false;
      store.timestamp = new Date().getTime();
    },
  },
});

export const { actions: analyticsActions, reducer: analyticsReducer } =
  analyticsSlice;
